<template>
    <el-dialog class="el-dialogs" :title="title" width="500px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="110px">
            <el-form-item label="处理方式：" prop="handlingMethod">
                <el-radio-group v-model="searchForm.handlingMethod" @input="changeMethod">
                    <el-radio label="0">撤回</el-radio>
                    <el-radio label="1">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="searchForm.handlingMethod == 0" key="ADFFA" label="撤回为：" prop="withdrawAs">
                <el-select v-model="searchForm.withdrawAs" size="small" style="width: 100%"
                           placeholder="请选择撤回为">
                    <el-option
                            v-for="item in withdrawAsList"
                            :key="item.basicRange"
                            :label="item.basicRange"
                            :value="item.basicRange">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="searchForm.handlingMethod == 0" label="撤回原因：" prop="cause">
                <el-input v-model.trim="searchForm.cause" maxlength="100"
                          placeholder="请输入撤回原因(限100字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item v-if="searchForm.handlingMethod == 1" label="隐藏字段：" prop="type">
                <el-radio-group v-model="searchForm.type" @change="changeHidden()">
                    <el-radio label="0">敏感字段</el-radio>
                    <el-radio label="1">全部字段</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="searchForm.handlingMethod == 1" key="ADSDSAG" label="字段选择：" prop="hiddenField">
                <el-select v-model="searchForm.hiddenField" size="small" style="width: 100%" multiple :loading="loading"
                           placeholder="请选择撤回为">
                    <div class="checkAll" @click="checkAllField()"
                         v-show="searchForm.hiddenField.length != hiddenFieldList.length">全选
                    </div>
                    <div class="checkAll" @click="checkAllField()"
                         v-show="searchForm.hiddenField.length == hiddenFieldList.length">取消全选
                    </div>
                    <el-option
                            v-for="item in hiddenFieldList"
                            :key="item.basic_code"
                            :label="item.basic_name"
                            :value="item.basic_code">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "urgentDeal",
    data() {
        return {
            title: '紧急处理',
            visible: false,
            loading: false,
            searchForm: {
                handlingMethod: '0',
                withdrawAs: '',
                type: '0',
                cause:'',
                hiddenField: [],
            },
            rules: {
                handlingMethod: [
                    {required: true, message: '请选择处理方式', trigger: 'change'}
                ],
                withdrawAs: [
                    {required: true, message: '请选择撤回为', trigger: 'change'}
                ],
                type: [
                    {required: true, message: '请选择隐藏字段', trigger: 'change'}
                ],
                hiddenField: [
                    {type: 'array', required: true, message: '请选择隐藏字段', trigger: 'change'}
                ],
                cause: [
                    {required: true, message: '请输入撤回原因', trigger: 'blur'}
                ],
            },
            withdrawAsList: [],
            hiddenFieldList: [],
            selectData: [],
        }
    },

    methods: {
        init(selectData) {
            this.visible = true
            this.selectData = selectData.map(item => {
                return item.id
            })
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            this.changeHidden()
            this.getOtherS()
        },

        getOtherS() {
            //获取资源的所有状态
            this.$axios(this.api.metadata.selectMetadataRangesByBasicId + '/1861299418288889859').then(data => {
                if (data && data.status) {
                    this.withdrawAsList = []
                    data.data.forEach(item => {
                        if (item.basicRange == '采集中') {
                            this.withdrawAsList.push(item)
                        }
                        if (item.basicRange == '整编中') {
                            this.withdrawAsList.push(item)
                        }
                        if (item.basicRange == '整编审核通过') {
                            this.withdrawAsList.push(item)
                        }
                    })
                }
            })
        },

        //切换处理方式
        changeMethod() {
            if (this.searchForm.handlingMethod == 0) {
                this.searchForm.type = '0'
                this.searchForm.hiddenField = []
            }
            if (this.searchForm.handlingMethod == 1) {
                this.searchForm.withdrawAs = ''
                this.searchForm.cause = ''
            }
        },

        changeHidden() {
            this.loading = true
            this.searchForm.hiddenField = []
            this.$axios(this.api.metadata.selectAllMetadataBasicByBasicCode, {
                basicId: this.selectData,
                type: this.searchForm.type
            }, 'post').then(data => {
                if (data && data.status) {
                    this.loading = false
                    this.hiddenFieldList = data.data
                }
            })
        },

        //隐藏字段全选
        checkAllField() {
            if (this.searchForm.hiddenField.length != this.hiddenFieldList.length) {
                this.searchForm.hiddenField = this.hiddenFieldList.map(item => {
                    return item.basic_code
                })
            } else {
                this.searchForm.hiddenField = []
            }
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.handlingMethod == 1) {
                        this.$confirm(`确定后资源在发布渠道能正常查看，隐藏的字段不可见。是否继续？`, '确认隐藏所选资源的相关字段？', {
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$axios(this.api.metadata.hiddenCommit, {
                                basicId: this.selectData,
                                field: this.searchForm.hiddenField,
                                type: this.searchForm.type,
                            }, 'post').then(data => {
                                if (data && data.status) {
                                    this.$message.success('提交成功')
                                    this.visible = false
                                    this.$emit('refresh')
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        })
                    } else {
                        this.$confirm(`撤回后资源将从发布渠道下架，从 “已发布“状态变更为撤回设置的状态，学术研究子系统资源只能回到【我的学术资源】，是否继续？`, '确认撤回所选资源？', {
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$axios(this.api.metadata.metadatadataDelist, {
                                ids: this.selectData,
                                status: this.searchForm.withdrawAs,
                                cause: this.searchForm.cause,
                            }, 'post').then(data => {
                                if (data && data.status) {
                                    this.$message.success('提交成功')
                                    this.visible = false
                                    this.$emit('refresh')
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        })
                    }
                }
            })
        },
    },
}
</script>

<style scoped>
.checkAll {
    cursor: pointer;
    font-size: 14px;
    padding-left: 15px;
    margin-bottom: 10px;
}
</style>